export class VModel {
  static use<P extends object, K extends keyof P, N extends string>(
    props: P,
    emit?: (name: N, ...args: any[]) => void,
    key: K = 'modelValue' as K
  ) {
    const { $emit } = ProxyEmit.use(emit)

    const event = `update:${key.toString()}` as N

    return computed({
      get() {
        return props[key]
      },
      set(value: any) {
        $emit(event, value)
      }
    })
  }
}
